import { render, staticRenderFns } from "./ForumPostImagesModal.vue?vue&type=template&id=2869396a"
import script from "./ForumPostImagesModal.vue?vue&type=script&lang=js"
export * from "./ForumPostImagesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports